/** Base garments tip names and their plain-text form. Pure: no React. */

/**
 * The tip texts of Base garments, by name. Each has `baseGarments.tips.<name>.title`
 * and `.body`; the body may carry <b>, <i>, <br/>, and <ul><li> bullets (R28).
 */
export type BaseGarmentTipName =
  | 'code'
  | 'name'
  | 'whoCanUse'
  | 'makeCopy'
  | 'printMethod'
  | 'lowStockAlert'
  | 'supplier'
  | 'hsCode'
  | 'setUp'
  | 'stockView'
  | 'supplyView'
  | 'costView'
  | 'weightView'
  | 'costByColour'
  | 'stockSave'
  | 'image'
  | 'noSize'
  | 'noColour'
  | 'substitute';

/** Rich tip text as one plain line: the (i)'s accessible name. */
export function plainTipText(text: string): string {
  return text
    .replace(/<br\s*\/?>/gi, ' ')
    // A bullet ends a sentence; one that already ends in a stop keeps its own.
    .replace(/([.!?。！？])?\s*<\/li>/gi, (_match, stop?: string) => (stop ? `${stop} ` : '. '))
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .replace(/\s+\./g, '.')
    // Sentences joined with ". " after one that already ends in a stop or a colon.
    .replace(/([.!?。！？:：])\.(?=\s|$)/g, '$1')
    .trim();
}
